import WebinarsShow from "../components/webinars/Show";

export default [
  { name: 'Webinars', path: '/webinars', component: WebinarsShow,  }
]
